import { render } from "./SettingsInfoBanner.vue?vue&type=template&id=00317edc&scoped=true"
import script from "./SettingsInfoBanner.vue?vue&type=script&lang=js"
export * from "./SettingsInfoBanner.vue?vue&type=script&lang=js"

import "./SettingsInfoBanner.vue?vue&type=style&index=0&id=00317edc&scoped=true&lang=css"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00317edc"]])

export default __exports__